(()=>{
  const q=(s,r=document)=>r.querySelector(s);

  const cookie=q('[data-vf-cookie]');
  const choices=q('[data-vf-cookie-choices]');

  const STORAGE_KEY='vendifox_cookie_consent_v1';

  const api=()=>window.Shopify&&window.Shopify.customerPrivacy;

  const hasLocalDecision=()=>{
    try{
      return localStorage.getItem(STORAGE_KEY)==='1';
    }catch(e){
      return false;
    }
  };

  const rememberDecision=()=>{
    try{
      localStorage.setItem(STORAGE_KEY,'1');
    }catch(e){}
  };

  const openCookie=()=>{
    if(!cookie)return;
    cookie.hidden=false;
    document.documentElement.classList.add('vf-cookie-open');
  };

  const closeCookie=()=>{
    if(!cookie)return;
    cookie.hidden=true;
    document.documentElement.classList.remove('vf-cookie-open');
  };

  function showCookie(force=false){
    if(!cookie)return;

    // Manueller Klick auf "Cookie-Einstellungen"
    // öffnet das Fenster immer.
    if(force){
      openCookie();
      return;
    }

    // Der Besucher hat auf dieser Domain bereits entschieden.
    if(hasLocalDecision()){
      closeCookie();
      return;
    }

    const privacy=api();

    // Shopify API noch nicht geladen:
    // NICHT vorsorglich das Banner öffnen.
    if(!privacy){
      return;
    }

    try{
      if(
        typeof privacy.shouldShowBanner==='function' &&
        privacy.shouldShowBanner()
      ){
        openCookie();
      }else{
        closeCookie();
      }
    }catch(e){
      // Bei API-Fehler nicht ungefragt erneut öffnen.
      closeCookie();
    }
  }

  function setConsent(v){
    const privacy=api();

    const done=()=>{
      rememberDecision();
      closeCookie();
    };

    if(
      privacy &&
      typeof privacy.setTrackingConsent==='function'
    ){
      try{
        privacy.setTrackingConsent(v,done);
      }catch(e){
        // Nicht fälschlich als erfolgreiche Shopify-Einwilligung speichern.
        closeCookie();
      }
    }else{
      // API nicht verfügbar: Fenster schließen, aber keine
      // vermeintlich erfolgreiche Consent-Entscheidung speichern.
      closeCookie();
    }
  }

  q('[data-vf-cookie-settings]')?.addEventListener('click',()=>{
    showCookie(true);
  });

  q('[data-vf-cookie-accept]')?.addEventListener('click',()=>{
    setConsent({
      analytics:true,
      marketing:true,
      preferences:true
    });
  });

  q('[data-vf-cookie-reject]')?.addEventListener('click',()=>{
    setConsent({
      analytics:false,
      marketing:false,
      preferences:false
    });
  });

  q('[data-vf-cookie-custom]')?.addEventListener('click',()=>{
    if(choices)choices.hidden=false;

    const save=q('[data-vf-cookie-save]');
    const accept=q('[data-vf-cookie-accept]');

    if(save)save.hidden=false;
    if(accept)accept.hidden=true;
  });

  q('[data-vf-cookie-save]')?.addEventListener('click',()=>{
    setConsent({
      preferences:q('[data-vf-consent="preferences"]')?.checked||false,
      analytics:q('[data-vf-consent="analytics"]')?.checked||false,
      marketing:q('[data-vf-consent="marketing"]')?.checked||false
    });
  });

  // Shopify Privacy API kann später als unser Theme geladen werden.
  // Deshalb warten wir kontrolliert darauf, statt das Banner bei
  // fehlender API automatisch zu öffnen.
  document.addEventListener('DOMContentLoaded',()=>{
    if(hasLocalDecision()){
      closeCookie();
      return;
    }

    let attempts=0;

    const waitForPrivacy=setInterval(()=>{
      attempts++;

      if(api()){
        clearInterval(waitForPrivacy);
        showCookie(false);
      }

      // Nach ca. 10 Sekunden aufhören.
      // Kein zusätzliches Banner erzwingen.
      if(attempts>=40){
        clearInterval(waitForPrivacy);
      }
    },250);
  });

  /*
   * Anfrage-Modal
   * Unverändert gegenüber deinem bisherigen Code.
   */
  const modal=q('[data-vf-inquiry]');

  const open=()=>{
    if(!modal)return;
    modal.hidden=false;
    document.documentElement.style.overflow='hidden';
    setTimeout(()=>q('input',modal)?.focus(),20);
  };

  const close=()=>{
    if(!modal)return;
    modal.hidden=true;
    document.documentElement.style.overflow='';
  };

  q('[data-vf-inquiry-open]')?.addEventListener('click',open);

  document
    .querySelectorAll('[data-vf-inquiry-close]')
    .forEach(x=>x.addEventListener('click',close));

  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'&&!modal?.hidden)close();
  });
})();